import React from "react";
import metal from "../Images/metal.png";
import copperscrap from "../Images/copperscrap.png";
import idustrialscrap from "../Images/industrialscrap.png";
import { Link } from "react-router-dom";
import Scrapservices1 from "./Scrapservices1.jsx";
import { User, ArrowRight, BookOpen, Tag } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Blog = () => {
  const navigate = useNavigate();
  const blog = [
    {
      id: 1,
      category: "Recycling",
      title: "Benefits of Metal Scrap Recycling",
      author: "Admin",
      image: metal,
      description:
        "Metal recycling helps conserve natural resources, reduce pollution and save energy.",
    },
    {
      id: 2,
      category: "Copper",
      title: "How Copper Scrap Adds Business Value",
      author: "Admin",
      image: copperscrap,
      description:
        "Copper scrap is one of the most valuable recyclable materials in the industry.",
    },
    {
      id: 3,
      category: "Industrial",
      title: "Industrial Scrap Management Guide",
      author: "Admin",
      image: idustrialscrap,
      description:
        "Learn the best practices for collecting, sorting and processing industrial scrap.",
    },
  ];

  const styles = {
    section: {
      padding: "100px 20px",
      background: "linear-gradient(135deg, #f4f8ff 0%, #eef4ff 100%)",
      fontFamily: "'Poppins', sans-serif",
    },

    container: {
      maxWidth: "1300px",
      margin: "0 auto",
    },

    headingBox: {
      textAlign: "center",
      marginBottom: "70px",
    },

    heading: {
      fontSize: "48px",
      fontWeight: "700",
      marginBottom: "15px",
      background: "linear-gradient(90deg,#0B2E7A,#1E5BFF)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },

    subHeading: {
      maxWidth: "700px",
      margin: "0 auto",
      color: "#666",
      lineHeight: "1.8",
      fontSize: "16px",
    },

    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit,minmax(340px,1fr))",
      gap: "35px",
    },

    card: {
      background: "#fff",
      borderRadius: "25px",
      overflow: "hidden",
      position: "relative",
      boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
      transition: "all 0.4s ease",
      cursor: "pointer",
    },

    imageWrapper: {
      height: "240px",
      overflow: "hidden",
    },

    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },

    content: {
      padding: "28px",
    },

    badge: {
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      padding: "8px 14px",
      borderRadius: "30px",
      background: "#eef3ff",
      color: "#0B2E7A",
      fontSize: "13px",
      fontWeight: "600",
      marginBottom: "18px",
      transition: "0.3s",
    },

    meta: {
      display: "flex",
      justifyContent: "space-between",
      color: "#777",
      fontSize: "14px",
      marginBottom: "18px",
      flexWrap: "wrap",
    },

    title: {
      fontSize: "22px",
      fontWeight: "700",
      color: "#0B2E7A",
      marginBottom: "15px",
      lineHeight: "1.5",
      transition: "0.3s",
    },

    description: {
      color: "#666",
      lineHeight: "1.8",
      marginBottom: "25px",
      transition: "0.3s",
    },

    button: {
      display: "inline-flex",
      alignItems: "center",
      gap: "10px",
      padding: "12px 22px",
      borderRadius: "50px",
      background: "linear-gradient(135deg,#0B2E7A,#1E5BFF)",
      color: "#fff",
      textDecoration: "none",
      fontWeight: "600",
      fontSize: "15px",
      transition: "0.4s",
      boxShadow: "0 8px 20px rgba(11,46,122,.25)",
       zIndex: 1000, 
    },
  };

  return (
    <>
      <style>
        {`
          .blog-card::before{
            content:'';
            position:absolute;
            top:0;
            left:0;
            width:100%;
            height:5px;
            background:linear-gradient(
              90deg,
              #FFD700,
              #0B2E7A
            );
          }

          .blog-card:hover{
            transform:translateY(-12px);
            box-shadow:0 25px 60px rgba(11,46,122,.18);
          }

          .blog-image{
            transition:.6s ease;
          }

          .blog-card:hover .blog-image{
            transform:scale(1.12);
          }

          .blog-title{
            transition:.3s ease;
          }

          .blog-card:hover .blog-title{
            color:#1748b5;
          }

          .blog-title{
  transition:.4s;
}

.blog-card:hover .blog-title{
  color:#1748b5;
  transform:translateX(5px);
}
   .blog-card::after{
  content:'';
  position:absolute;
  inset:0;
  background:
  linear-gradient(
  135deg,
  rgba(255,215,0,.05),
  rgba(11,46,122,.05)
  );
  opacity:0;
  transition:.4s;
   pointer-events:none;
}

.blog-card:hover::after{
  opacity:1;
}  

          .blog-description{
            transition:.3s ease;
          }

          .blog-card:hover .blog-description{
            color:#333;
          }

          .blog-badge{
            transition:.3s ease;
          }

          .blog-card:hover .blog-badge{
            background:#0B2E7A;
            color:#fff;
          }

          .read-more{
            transition:.3s ease;
          }

          .blog-card:hover .read-more{
            color:#ff9800;
          }

          .blog-card:hover .read-more svg{
            transform:translateX(8px);
          }

          .read-more svg{
            transition:.3s ease;
          }

          .read-more:hover{
            letter-spacing:1px;
          }

          .read-more{
  position:relative;
  overflow:hidden;
}

.read-more::before{
  content:'';
  position:absolute;
  top:0;
  left:-120%;
  width:100%;
  height:100%;
  background:rgba(255,255,255,0.25);
  transform:skewX(-25deg);
  transition:.6s;
}

.read-more:hover::before{
  left:120%;
}

.read-more:hover{
  transform:translateY(-5px) scale(1.05);
  box-shadow:0 18px 40px rgba(11,46,122,.35);
}

.read-more svg{
  transition:.4s ease;
}

.read-more:hover svg{
  transform:translateX(8px);
}
  /* Book Icon Animation */

.book-icon{
  cursor:pointer;
  animation:floatBook 3s ease-in-out infinite;
  transition:all .4s ease;
}

.book-icon:hover{
  transform:scale(1.2) rotate(10deg);
  color:#ff9800;
  filter:drop-shadow(0 10px 20px rgba(255,152,0,.4));
}

@keyframes floatBook{
  0%{
    transform:translateY(0px);
  }

  50%{
    transform:translateY(-10px);
  }

  100%{
    transform:translateY(0px);
  }
}

/* Continuous Pulse Animation */

@keyframes pulseBtn{
  0%{
    box-shadow:0 0 0 0 rgba(11,46,122,.4);
  }

  70%{
    box-shadow:0 0 0 12px rgba(11,46,122,0);
  }

  100%{
    box-shadow:0 0 0 0 rgba(11,46,122,0);
  }
}

.read-more{
  animation:pulseBtn 2s infinite;
}
        .blog-heading{
  display:inline-block;
  cursor:pointer;
  transition:all .4s ease;
}

.blog-heading:hover{
  transform:translateY(-5px) scale(1.03);
  filter:drop-shadow(0 10px 20px rgba(11,46,122,.25));
}

          @media(max-width:768px){

            .blog-heading{
              font-size:34px !important;
            }

            .blog-meta{
              gap:10px;
            }

          }
            .read-more{
  position:relative;
  overflow:hidden;
  transition:.4s ease;
}

.read-more:hover{
  transform:translateY(-3px);
  box-shadow:0 15px 35px rgba(11,46,122,.35);
}

.read-more::before{
  content:'';
  position:absolute;
  top:0;
  left:-100%;
  width:100%;
  height:100%;
  background:rgba(255,255,255,.2);
  transition:.5s;
}

.read-more:hover::before{
  left:100%;
}

.read-more svg{
  transition:.4s;
}

.read-more:hover svg{
  transform:translateX(8px);
}
        `}
      </style>

      <section style={styles.section}>
        <div style={styles.container}>
          <div style={styles.headingBox}>
            <BookOpen size={40} color="#0B2E7A" className="book-icon" />

            <h2 className="blog-heading" style={styles.heading}>
              Latest Blogs & Insights
            </h2>

            <p style={styles.subHeading}>
              Stay updated with scrap industry trends, recycling insights,
              market updates and valuable business knowledge.
            </p>
          </div>

          <div style={styles.grid}>
            {blog.map((item) => (
              <div key={item.id} className="blog-card" style={styles.card}>
                <div style={styles.imageWrapper}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className="blog-image"
                    style={styles.image}
                  />
                </div>

                <div style={styles.content}>
                  <div className="blog-badge" style={styles.badge}>
                    <Tag size={14} />
                    {item.category}
                  </div>

                  <div
                    className="blog-meta"
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "18px",
                      color: "#666",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <User size={14} />
                      {item.author}
                    </span>
                  </div>

                  <h3 className="blog-title" style={styles.title}>
                    {item.title}
                  </h3>

                  <p className="blog-description" style={styles.description}>
                    {item.description}
                  </p>

                  <button
                    onClick={() => {
                      console.log("Button Clicked");
                      navigate("/Scrapservices1");
                    }}
                    className="read-more"
                    style={styles.button}
                  >
                    Read More
                    <ArrowRight size={18} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
